<template>
  <div>
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <h2 class="pl-2">{{ $t("labels.activities") }}</h2>
    </div>
    <vx-card>
      <div class="vx-row w-full mt-4 m-0">
        <div class="vx-col w-full mb-4 set_limit pl-0 pr-0">
          <label class="limit_label">{{ $t("labels.show") }}</label>
          <v-select
            v-model="limit"
            :options="limitarr"
            :reduce="(limitarr) => limitarr.value"
            :clearable="false"
            label="text"
            class="px-1"
          />
          <label class="limit_label">{{ $t("labels.activities") }}</label>
        </div>
      </div>
      <vs-table :data="activities" class="vessel-listing permission">
        <template slot="thead">
          <vs-th class="col-md-3">{{ $t("labels.description") }}</vs-th>
          <vs-th class="col-md-3">{{ $t("labels.changes") }}</vs-th>
          <vs-th class="col-md-3">{{ $t("labels.causer") }}</vs-th>
          <vs-th class="col-md-3">{{ $t("labels.time") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :inner-html.prop="tr.description | show_description"></vs-td>
            <vs-td
              :inner-html.prop="tr.properties | show_changes(tr.description)"
            ></vs-td>
            <vs-td :inner-html.prop="tr.causer | show_causer"></vs-td>
            <vs-td :data="tr.created_at">{{
              tr.created_at | date_format
            }}</vs-td>
            <!-- <vs-td>{{tr}}</vs-td> -->
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: "list-activities",
  props: {
    model: { required: true },
    id: { required: true },
  },
  data() {
    return {
      activities: [],
      totalPage: 1,
      currentx: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
    };
  },
  watch: {
    limit() {
      this.currentx = 1;
      this.getActivities();
    },
    currentx() {
      this.getActivities();
    },
  },
  mounted() {
    this.getActivities();
  },
  methods: {
    async getActivities() {
      let input = {
        model: this.model,
        id: this.id,
        page: this.currentx,
        perPage: this.limit,
        search: this.search,
      };

      let response = await this.getHTTPPostResponse("/activities", input);
      if (response) {
        let data = response.data;
        this.activities = data.activities;
        let perPage = this.limit;
        let totalPage = Math.ceil(response.data.count / perPage);
        this.totalPage = totalPage;
      }
    },
    goBack() {
      history.back();
    },
  },
  filters: {
    show_description(description) {
      var html = ``;
      if (description == "created") {
        html = `<li class="test"><span class="text-success">Created</span></li>`;
      } else if (description == "updated") {
        html = `<li class="test"><span class="text-warning">Updated</span></li>`;
      } else if (description == "deleted") {
        html = `<li class="test"><span class="text-danger">Deleted</span></li>`;
      } else {
        html = description;
      }
      return html;
    },
    show_changes(properties, description) {
      var html = ``;
      if (description == "created") {
        for (let key in properties.attributes) {
          if (properties.attributes[key]) {
            html += `<li class="test"><b>${key}</b> : <span class="text-success">${properties.attributes[key]}</span></li>`;
          }
        }
      } else if (description == "updated") {
        for (let key in properties.old) {
          html += `<li class="test"><b>${key}</b> : <i class="text-danger">${properties.old[key]}</i> -> <span class="text-success">${properties.attributes[key]}</span></li>`;
        }
      } else if (description == "deleted") {
        for (let key in properties.attributes) {
          if (properties.attributes[key]) {
            html += `<li class="test"><b>${key}</b> :  <i class="text-danger">${properties.attributes[key]}</i></li>`;
          }
        }
      } else {
        html = `TO_BE_DONE`;
      }
      return html;
    },
    show_causer(causer) {
      return `${causer.name}`;
    },
  },
};
</script>

<style>
.test {
  list-style-type: none;
}
h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-primary), 1);
}
</style>
